import { useState } from 'react'
import { Container, Dropdown, ListGroup, NavLink, Stack, Card, Badge, Button } from 'react-bootstrap'
import { ITextBlock } from '../../../models/ITextblock';
import ViewTextBlock from '../Views/ViewTextBlock';
import { useQuery } from 'react-query';
import { getTextBlocks } from '../../../api/agent';
import { ObjectId } from '../../../models';
// import TextBlockStatus from './Train/TextBlockStatus';
// import DeleteTextBlock from '../Delete/DeleteTextBlock';
import { useOrgContext } from '../../../context/org';
import { FaFileAlt, FaEdit, FaTrash, FaEllipsisV, FaClock } from 'react-icons/fa';
import ManageTextBlock from '../ManageTextBlock';
import DataStatus from '../DataStatus';
import DeleteDataItem from '../DeleteDataItem';

type Props = {
	orgId: ObjectId;
	textBlocks: ITextBlock[];
	permission: boolean;
}

function ListTextBlocks({ orgId, textBlocks, permission }: Props) {
    const [editTextBlock, setEditTextBlock] = useState<ITextBlock>();
    const [deleteItem, setDeleteItem] = useState<{
        show: boolean;
        id: string;
        name: string;
		agentId: string;
    }>({ show: false, id: '', name: '', agentId: '' });
   
  return (
	<>
		{editTextBlock && 
			<ManageTextBlock 
				show={true}
				setShow={(show) => !show && setEditTextBlock(undefined)}
				textBlock={editTextBlock} 
			/>
		}
		{
			<DeleteDataItem 
				show={deleteItem.show}
                onClose={() => setDeleteItem({ show: false, id: '', name: '', agentId: '' })}
                orgId={orgId}
                agentId={deleteItem.agentId}
                itemId={deleteItem.id}
                itemType="textBlock"
                itemName={deleteItem.name}
			/>
		}
		
		<div 
			className="mb-4"
			style={{ backgroundColor: "#2d2d2d", borderRadius: "12px", border: "1px solid #444" }}
		>
			{/* Header */}
			<div className="p-4 border-bottom" style={{ borderColor: "#555" }}>
				<div className="d-flex align-items-center justify-content-between">
					<div className="d-flex align-items-center">
						<div 
							className="me-3 d-flex align-items-center justify-content-center"
							style={{
								width: "32px",
								height: "32px",
								backgroundColor: "#007bff",
								borderRadius: "8px"
							}}
						>
							<FaFileAlt className="text-white" size={16} />
						</div>
						<h5 className="text-light mb-0" style={{ fontSize: "18px", fontWeight: "600" }}>
							Text Blocks
						</h5>
					</div>
					<Badge bg="secondary" className="px-2 py-1">
						{textBlocks.length} items
					</Badge>
				</div>
			</div>

			{/* Content */}
			<div className="p-0">
				{textBlocks.map((textBlock, index) => (
					<div 
						key={index}
						className="p-4 d-flex align-items-center justify-content-between"
						style={{ 
							borderBottom: index < textBlocks.length - 1 ? "1px solid #444" : "none",
							transition: "background-color 0.2s ease"
						}}
						onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#333"}
						onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
					>
						<div className="flex-grow-1">
							<div className="d-flex align-items-center mb-2">
								<button
									className="btn btn-link p-0 text-decoration-none"
									onClick={() => setEditTextBlock(textBlock)}
									style={{ 
										fontSize: "16px", 
										fontWeight: "500",
										color: "#fff",
										border: "none",
										background: "none"
									}}
									onMouseEnter={(e) => e.currentTarget.style.color = "#007bff"}
									onMouseLeave={(e) => e.currentTarget.style.color = "#fff"}
								>
									{textBlock.title}
								</button>
							</div>
							<div className="d-flex align-items-center" style={{ fontSize: "14px", color: "#ccc" }}>
								<FaClock className="me-2" size={12} />
								<span>Updated {new Date(textBlock.updatedAt).toDateString()}</span>
							</div>
						</div>

						<div className="d-flex align-items-center">
							<div className="me-3">
								<DataStatus 
									orgId={orgId} 
									id={textBlock.id} 
									agentId={textBlock.agentId} 
									status={textBlock.status}
									type='textBlock'
								/>
							</div>
							
							<Dropdown align="end">
								<Dropdown.Toggle 
									variant="link"
									className="p-0 border-0"
									disabled={permission}
									style={{ fontSize: "14px", color: "#ccc" }}
								>
									<FaEllipsisV />
								</Dropdown.Toggle>

								<Dropdown.Menu
									style={{ 
										backgroundColor: "#333", 
										borderColor: "#555",
										minWidth: "120px"
									}}
								>
									<Dropdown.Item 
										onClick={() => setEditTextBlock(textBlock)}
										className="d-flex align-items-center"
										style={{ 
											fontSize: "14px", 
											color: "#fff",
											backgroundColor: "transparent"
										}}
										onMouseEnter={(e) => {
											e.currentTarget.style.backgroundColor = "#007bff";
											e.currentTarget.style.color = "#fff";
										}}
										onMouseLeave={(e) => {
											e.currentTarget.style.backgroundColor = "transparent";
											e.currentTarget.style.color = "#fff";
										}}
									>
										<FaEdit className="me-2" size={12} />
										Edit
									</Dropdown.Item>
									<Dropdown.Item 
										// onClick={() => setDeleteTextBlock(textBlock)}
										onClick={() => setDeleteItem({ 
											show: true, 
											id: textBlock.id, 
											name: textBlock.title,
											agentId: textBlock.agentId
										})}
										className="d-flex align-items-center"
										style={{ 
											fontSize: "14px", 
											color: "#fff",
											backgroundColor: "transparent"
										}}
										onMouseEnter={(e) => {
											e.currentTarget.style.backgroundColor = "#dc3545";
											e.currentTarget.style.color = "#fff";
										}}
										onMouseLeave={(e) => {
											e.currentTarget.style.backgroundColor = "transparent";
											e.currentTarget.style.color = "#fff";
										}}
									>
										<FaTrash className="me-2" size={12} />
										Delete
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>
				))}
			</div>
		</div>
	</>
  )
}

export default ListTextBlocks